import React from "react";
import { Box, Container, Paper, Typography, Divider } from "@mui/material";

const PrivacyPolicy = () => {
    return (
        <Box sx={{ py: 5, background: "#fafafa" }}>
            <Container maxWidth="md">

                <Typography
                    variant="h3"
                    align="center"
                    color="#f5b600"
                    fontWeight="bold"
                    gutterBottom
                >
                    Privacy Policy
                </Typography>

                <Paper sx={{ p: 4, borderRadius: 3 }}>

                    <Typography paragraph>
                        At <strong>SDHR InnoWorks Private Limited</strong>, we value
                        your privacy and are committed to protecting your personal
                        information.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h5">
                        Information We Collect
                    </Typography>

                    <Typography paragraph>
                        • Name
                        <br />
                        • Email Address
                        <br />
                        • Phone Number
                        <br />
                        • Shipping Address
                        <br />
                        • Billing Information
                    </Typography>

                    <Typography variant="h5">
                        How We Use Your Information
                    </Typography>

                    <Typography paragraph>
                        We use your information to:
                        <br />
                        • Process orders
                        <br />
                        • Deliver products
                        <br />
                        • Improve customer service
                        <br />
                        • Send order updates
                    </Typography>

                    <Typography variant="h5">
                        Payment Security
                    </Typography>

                    <Typography paragraph>
                        Payment information is securely processed through trusted
                        payment gateways. We do not store complete card details.
                    </Typography>

                    <Typography variant="h5">
                        Data Protection
                    </Typography>

                    <Typography paragraph>
                        We implement appropriate security measures to protect your
                        personal information from unauthorized access.
                    </Typography>

                    <Typography variant="h5">
                        Cookies
                    </Typography>

                    <Typography paragraph>
                        Our website may use cookies to improve browsing experience
                        and website functionality.
                    </Typography>

                    <Typography variant="h5">
                        Third Party Sharing
                    </Typography>

                    <Typography paragraph>
                        We do not sell customer information. Information may be
                        shared only with trusted logistics or payment partners
                        necessary for order fulfillment.
                    </Typography>

                    <Typography variant="h5">
                        Contact
                    </Typography>

                    <Typography>Email: sdhrinnoworks@gmail.com</Typography>
                    <Typography>Mobile. No.: +91 9347566010</Typography>

                </Paper>

            </Container>
        </Box>
    );
};

export default PrivacyPolicy;